<template>
  <div :class="{'monitor-view-wrapper': isMonitorView}" id="monitor-view">
    <div class="mt-4 px-5">

      <h2>Heute</h2>

      <div :class="{'monitor-view': isMonitorView, 'normal-view': !isMonitorView}">
        <v-data-table
          v-if="show_SL"
          :class="{'large-table': isMonitorView}"
          :headers="comp_Table_Header_SL"
          :items="comp_TodaySL"
          class="elevation-1 my-2"
          ref="TodaySL"
          no-data-text="Kein Schiessleiter eingebucht"
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat color="warning">
              <h3>Schiessleiter</h3>
              <v-spacer></v-spacer>
              <v-btn icon @click="getTodaySL">
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:item.beginn="{ item }">
            <span>{{
                new Date(item.beginn.replace(" ", "T")).toLocaleString([], { dateStyle: "short", timeStyle: "short" })
              }}</span>
          </template>

          <template v-slot:item.beenden="{ item }">
            <v-btn class="error my-1" text @click="ende_other_aufsicht(item)">
              <v-icon>mdi-clock-end</v-icon>
            </v-btn>
          </template>

        </v-data-table>

        <v-data-table
          v-if="show_SA"
          :class="{'large-table': isMonitorView}"
          :headers="comp_Table_Header_SA"
          :items="comp_TodaySA"
          class="elevation-1 my-2"
          ref="TodaySA"
          no-data-text="Kein Standaufsicht eingebucht, eingeschränkter Schiessbetrieb!"
          hide-default-footer
          :item-class="itemRowClass"
        >
          <template v-slot:top>
            <v-toolbar flat color="info">
              <h3>Standaufsicht</h3>
              <v-spacer></v-spacer>
              <v-btn icon @click="getTodaySA">
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:item.beginn="{ item }">
            <span>{{
                new Date(item.beginn.replace(" ", "T")).toLocaleString([], { dateStyle: "short", timeStyle: "short" })
              }}</span>
          </template>

          <template v-slot:item.beenden="{ item }">
            <v-btn class="error my-1" text @click="ende_other_aufsicht(item)">
              <v-icon>mdi-clock-end</v-icon>
            </v-btn>
          </template>

          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.allein_aufsicht="{ item }">
            <v-icon v-if="!item.allein_aufsicht" color="success">mdi-check</v-icon>
            <v-icon v-if="item.allein_aufsicht" color="red">mdi-window-close</v-icon>
          </template>
        </v-data-table>
      </div>

      <v-data-table
        v-if="show_user"
        :headers="headers"
        :items="comp_TodayMember"
        sort-by="KurzBez"
        group-by="KurzBez"
        class="elevation-1 my-2"
        ref="TodayMember"
        no-data-text="Kein Schütze eingebucht"
      >
        <template v-slot:top>
          <v-toolbar flat color="success">
            <h3>Schützen</h3>
            <v-spacer></v-spacer>
            <v-btn icon @click="getTodayMember">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.beginn="{ item }">
          <span>{{
              new Date(item.beginn.replace(" ", "T")).toLocaleString([], { dateStyle: "short", timeStyle: "short" })
            }}</span>
        </template>
      </v-data-table>

      <!-- Uhr: im Monitor-Modus sichtbar und „in“ die App-Leiste eingepasst -->
      <div
        v-if="isMonitorView && showClock"
        class="appbar-clock"
        :style="clockInlineStyle"
        aria-label="Aktuelle Uhrzeit"
      >
        {{ currentTime }}
      </div>

    </div>
  </div>
</template>

<script>
import client, { initializeAblyClient, closeAblyClient } from "@/plugins/ably";
import { API } from "@/plugins/axios";

export default {
  name: "today",
  data: () => ({
    polling: null,
    dialog: false,
    dialogDelete: false,
    loading: false,
    show_SL: true,
    show_SA: true,
    show_user: true,
    channel: null,
    channel2: null,
    range_id_param: null,
    isMonitorView: false,
    shouldReconnect: true,
    websocketRestartId: null,
    currentTime: "",
    showClock: true,
    timeIntervalId: null,

    // Re-Auth Steuerung (Monitor-URL)
    reauthTimeoutId: null,
    reauthIntervalMs: 55 * 60 * 1000, // 55 Minuten (vor 59 Min. Ablauf)
    reauthInProgress: false,

    // Lokale Interceptor-IDs (nur Monitor-Modus)
    monitorAxiosInterceptorId: null,
    monitorReqInterceptorId: null,

    clockInlineStyle: {},

    headers_Table_Action: [
      { text: "Aufsicht Regulär", align: "center", value: "allein_aufsicht", width: "100px" },
      { text: "Beenden", value: "beenden", align: "right", width: "250px" }
    ],
    headers: [
      { text: "Name", value: "name", align: "left", width: "250px", sortable: false },
      { text: "Vorname", value: "vorname", align: "left", width: "250px" },
      { text: "Begin", value: "BeginFormat", align: "left", width: "250px" },
      { text: "Stand", value: "KurzBez", align: "left", width: "250px" },
      { text: "Bahn", value: "bahn", align: "left", width: "250px" }
    ],
    headers_SA: [
      { text: "Name", value: "name", align: "left", sortable: false, width: "250px" },
      { text: "Vorname", value: "vorname", align: "left", width: "250px" },
      { text: "Begin", value: "BeginFormat", align: "left", width: "250px" },
      { text: "Stand", value: "KurzBez", align: "left", width: "250px" }
    ],
    headers_SL: [
      { text: "Name", value: "name", align: "left", sortable: false, width: "250px" },
      { text: "Vorname", value: "vorname", align: "left", width: "250px" },
      { text: "Begin", value: "BeginFormat", align: "left", width: "250px" }
    ]
  }),

  computed: {
    comp_TodayMember() {
      return this.$store.state.ClubApp.TodayMember;
    },
    comp_TodaySA() {
      const SAList = this.$store.state.ClubApp.TodaySA;
      if (this.range_id_param) {
        return SAList.filter(sa => this.range_id_param.includes(sa.shootingrange_id));
      }
      return SAList;
    },
    comp_TodaySL() {
      return this.$store.state.ClubApp.TodaySL;
    },
    isClubLoggedIn() {
      return this.$store.getters["ClubAuth/isClubLoggedIn"];
    },
    isClubID() {
      return this.$store.getters["ClubAuth/isClubID"];
    },
    comp_Table_Header_SA() {
      let header_SA = [...this.headers_SA];
      if (!this.isMonitorView) {
        header_SA = [...this.headers_SA, ...this.headers_Table_Action];
      }
      return header_SA;
    },
    comp_Table_Header_SL() {
      let header_SL = [...this.headers_SL];
      if (!this.isMonitorView) {
        header_SL = [...this.headers_SL, ...this.headers_Table_Action];
      }
      return header_SL;
    }
  },

  async created() {
    this.shouldReconnect = true;
    const params = this.$route.params;

    if (Object.keys(params).length === 0) {
      // Normaler Aufruf (kein Token/Monitor)
      this.$store.commit("GeneralApp/SET_SHOW_NAVIGATION", true);
      await this.getTodaySA();
      await this.getTodaySL();
      await this.getTodayMember();
      await this.start_websocket();
    } else {
      // Token-/Monitor-Modus
      this.isMonitorView = true;

      // Uhr via Query-Parameter schalten: ?clock=0|false|off -> aus
      const q = this.$route.query && this.$route.query.clock;
      this.showClock = !(q === "0" || q === "false" || q === "off");

      // Monitor-Info (für Interceptor)
      localStorage.setItem("monitorMode", "1");
      localStorage.setItem("monitorClubId", params.clubid || "");
      localStorage.setItem("monitorQrToken", params.token || "");

      // Alle Requests im Monitor-Modus markieren
      this.monitorReqInterceptorId = API.interceptors.request.use(cfg => {
        cfg.headers = cfg.headers || {};
        cfg.headers["X-Monitor-Mode"] = "1";
        return cfg;
      });

      await this.loginwithToken();
      this.updateTime();
      this.applyMonitorViewStyles();

      // stilles Re-Authenticate zyklisch einplanen
      this.scheduleReauth();

      // Axios-Interceptor installieren (nur Token-Modus)
      this.installMonitorInterceptor();

      this.$nextTick(() => {
        this.updateClockInlineStyle();
        window.addEventListener("resize", this.updateClockInlineStyle, { passive: true });
      });
    }
  },

  beforeDestroy() {
    this.shouldReconnect = false;
    if (this.channel) this.channel.unsubscribe();
    if (this.channel2) this.channel2.unsubscribe();
    if (this.websocketRestartId) {
      clearTimeout(this.websocketRestartId);
      this.websocketRestartId = null;
    }
    closeAblyClient();
    this.$store.dispatch("GeneralApp/Websocket_state", false);
    if (this.isMonitorView) {
      this.removeMonitorViewStyles();
      window.removeEventListener("resize", this.updateClockInlineStyle);
    }
    if (this.timeIntervalId) {
      clearInterval(this.timeIntervalId);
      this.timeIntervalId = null;
    }

    // Re-Auth Timer bereinigen
    this.clearReauth();

    // Lokale Interceptors entfernen
    if (this.monitorReqInterceptorId !== null) {
      API.interceptors.request.eject(this.monitorReqInterceptorId);
      this.monitorReqInterceptorId = null;
    }
    this.ejectMonitorInterceptor();

    // Monitor-Flags entfernen
    localStorage.removeItem("monitorMode");
    localStorage.removeItem("monitorClubId");
    localStorage.removeItem("monitorQrToken");
  },

  methods: {
    start_websocket() {
      if (!this.shouldReconnect) {
        console.log("Seite verlassen, Websocket wird nicht gestartet.");
        return;
      }
      // Ohne Club-Token würde Ably nur endlos 401 bekommen (z. B. fehlgeschlagener Monitor-Login)
      if (!this.$store.getters["ClubAuth/isClubToken"]) {
        console.warn("Kein Club-Token, Websocket wird nicht gestartet.");
        return;
      }

      // Neuer Client → Kanäle neu abonnieren. Das Wiederverbinden nach disconnected/suspended
      // übernimmt Ably selbst, den Token holt es dabei jedes Mal frisch (authCallback).
      this.channel = null;
      this.channel2 = null;
      const ably = initializeAblyClient();

      ably.connection.on((stateChange) => {
        console.log("Verbindungsstatus: ", stateChange.current);

        if (stateChange.current === "connected") {
          if (!this.channel) this.subscribeChannels(ably);
          this.$store.dispatch("GeneralApp/Websocket_state", true);
        }

        if (stateChange.current === "disconnected" || stateChange.current === "suspended") {
          console.warn("Ably client ist getrennt, Ably verbindet selbst neu...");
          this.$store.dispatch("GeneralApp/Websocket_state", false);
        }

        // failed: Ably versucht es nicht mehr selbst → nach einer Pause neuer Client, solange die Seite offen ist
        if (stateChange.current === "failed") {
          console.error("Ably Verbindung fehlgeschlagen:", stateChange.reason);
          this.$store.dispatch("GeneralApp/Websocket_state", false);
          this.scheduleWebsocketRestart();
        }

        // closed: nur durch uns (Seite verlassen, Abmeldung, neuer Client) – kein Neustart
        if (stateChange.current === "closed") {
          this.$store.dispatch("GeneralApp/Websocket_state", false);
        }
      });
    },

    scheduleWebsocketRestart() {
      if (this.websocketRestartId) clearTimeout(this.websocketRestartId);
      this.websocketRestartId = setTimeout(() => {
        this.websocketRestartId = null;
        this.start_websocket();
      }, 30000);
    },

    subscribeChannels(ably) {
      this.channel = ably.channels.get("private:clubs." + this.isClubID + ".ClubTodayChannel");
      this.channel2 = ably.channels.get("clubs/" + this.isClubID + "/range_safty");

      this.channel.subscribe((message) => {
        if (message?.data?.message) {
          const { Today, TodaySA, TodaySL } = message.data.message;
          if (TodaySA && TodaySL && Today) {
            this.$store.commit("ClubApp/get_TodaySA", TodaySA);
            this.$store.commit("ClubApp/get_TodaySL", TodaySL);
            this.$store.commit("ClubApp/get_TodayMember", Today);
          } else {
            console.error("Ungültige Datenstruktur:", message.data);
          }
        } else {
          console.error("Nachricht nicht lesbar oder ungültig:", message);
        }
      });

      this.channel2.subscribe((msg) => {
        const jsonString = new TextDecoder().decode(msg.data);
        try {
          const data = JSON.parse(jsonString);
          console.log(data);
        } catch (e) {
          console.error("Konnte den Nachrichteninhalt nicht als JSON parsen", e);
        }
      });
    },

    updateTime() {
      this.timeIntervalId = setInterval(() => {
        const now = new Date();
        this.currentTime = now.toLocaleTimeString(["de-DE"], { hour: "2-digit", minute: "2-digit" });
      }, 1000);
    },

    // Re-Auth: zyklisch planen und wiederholen
    scheduleReauth() {
      this.clearReauth();
      this.reauthTimeoutId = setTimeout(() => {
        this.reauthenticateWithToken("timer").finally(() => {
          this.scheduleReauth();
        });
      }, this.reauthIntervalMs);
    },
    clearReauth() {
      if (this.reauthTimeoutId) {
        clearTimeout(this.reauthTimeoutId);
        this.reauthTimeoutId = null;
      }
    },
    async reauthenticateWithToken(trigger = "manual") {
      if (this.reauthInProgress) return;
      this.reauthInProgress = true;
      try {
        const { clubid, token } = this.$route.params || {};
        if (!clubid || !token) {
          this.reauthInProgress = false;
          return;
        }

        await this.$store.dispatch("ClubAuth/login", { clubid, token });

        // Ein laufender Ably-Client holt sich den neuen Token selbst; neu starten nur, wenn keiner läuft.
        // Dann war der Monitor ohne Verbindung → Daten einmal neu laden.
        try {
          if (!client) {
            this.start_websocket();
            this.getTodaySA();
            this.getTodaySL();
            this.getTodayMember();
          }
        } catch (e) {
          console.warn("Websocket Neustart nach Reauth fehlgeschlagen:", e);
        }
      } catch (e) {
        console.error("Reauth fehlgeschlagen (" + trigger + "):", e);
        // Nach dem Verlassen der Seite nicht weiter versuchen; 30 s Pause schont das Backend bei Störungen
        setTimeout(() => {
          this.reauthInProgress = false;
          if (this.shouldReconnect) this.reauthenticateWithToken("retry");
        }, 30000);
        return;
      }
      this.reauthInProgress = false;
    },

    // Axios-Response-Interceptor NUR im Token-/Monitor-Modus:
    // fängt 401/419 ab, reauthentifiziert still und wiederholt den Request
    installMonitorInterceptor() {
      const isTokenMode = this.isMonitorView && this.$route.name === "/club/today_monitor" && !!this.$route.params.token;
      if (!isTokenMode || this.monitorAxiosInterceptorId !== null) return;

      this.monitorAxiosInterceptorId = API.interceptors.response.use(
        response => response,
        async (error) => {
          const status = error?.response?.status;
          const originalConfig = error?.config || {};
          const eligible = status === 401 || status === 419;

          if (!eligible) return Promise.reject(error);

          if (originalConfig._retry) return Promise.reject(error);
          originalConfig._retry = true;

          try {
            await this.reauthenticateWithToken("axios-interceptor");

            // falls wir auf /login gelandet sind, zum redirect zurück
            try {
              const current = this.$router.currentRoute;
              const isOnLogin = current && current.path && current.path.startsWith("/login");
              const redirect = current && current.query && current.query.redirect;
              if (isOnLogin && redirect) {
                await this.$router.replace(decodeURIComponent(redirect));
              }
            } catch (e) {
              // ignore
            }

            return API.request(originalConfig);
          } catch (e) {
            return Promise.reject(error);
          }
        }
      );
    },
    ejectMonitorInterceptor() {
      if (this.monitorAxiosInterceptorId !== null) {
        API.interceptors.response.eject(this.monitorAxiosInterceptorId);
        this.monitorAxiosInterceptorId = null;
      }
    },

    // Uhr optisch in die App-Leiste integrieren (Größe/Farbe/Position)
    updateClockInlineStyle() {
      const appBar = document.querySelector(".v-app-bar, .v-toolbar");
      const rect = appBar ? appBar.getBoundingClientRect() : { height: 64, top: 0 };
      const bg = appBar ? getComputedStyle(appBar).backgroundColor : "rgb(76,175,80)";

      const rgba = this.rgbToRgba(bg, 0.92);

      const height = Math.max(44, Math.min(80, rect.height - 10));
      const fontSize = Math.round(height * 0.45);

      this.clockInlineStyle = {
        top: `${(rect.top || 0) + 5}px`,
        right: "14px",
        height: `${height}px`,
        lineHeight: `${height}px`,
        fontSize: `${fontSize}px`,
        backgroundColor: rgba,
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        borderRadius: "8px",
        padding: "0 14px"
      };
    },
    rgbToRgba(c, a) {
      if (!c) return `rgba(0,0,0,${a})`;
      const m = c.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)/i);
      if (!m) return `rgba(0,0,0,${a})`;
      const r = m[1], g = m[2], b = m[3];
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },

    getTodayMember() {
      if (this.show_user) {
        this.$store.dispatch("ClubApp/getTodayMember");
      }
    },
    getTodaySA() {
      if (this.show_SA) {
        this.$store.dispatch("ClubApp/getTodaySA");
      }
    },
    getTodaySL() {
      if (this.show_SL) {
        this.$store.dispatch("ClubApp/getTodaySL");
      }
    },
    ende_other_aufsicht(item) {
      const Data = { shootingbook_id: item.id };
      this.$store.dispatch("ClubApp/end_other_aufsicht", Data);
    },

    itemRowClass(item) {
      var Class = null;
      if (item.allein_aufsicht === 1) {
        Class = "blue lighten-4";
      } else if (item.allein_aufsicht === 0) {
        Class = "";
      }
      return Class;
    },

    async loginwithToken() {
      const params = this.$route.params;
      const token = params.token;
      const clubid = params.clubid;

      // '/club/today_monitor/:clubid/:token/:rangeid?' /14,15,20
      if (params.rangeid) {
        this.range_id_param = params.rangeid.split(",").map(Number);
      } else {
        this.range_id_param = null;
      }

      const data = { clubid, token };

      this.show_user = false;
      this.show_SL = false;
      this.show_SA = true;

      await this.$store.dispatch("ClubAuth/login", data)
        .then(() => {
          this.$store.commit("GeneralApp/SET_SHOW_NAVIGATION", false);
          this.start_websocket();
        })
        .catch(err => {
          // Monitor bleibt stehen und versucht es weiter, statt mit altem Token Ably zu starten
          console.log(err);
          this.reauthenticateWithToken("login-failed");
        })
        .finally(this.getTodaySA)
        .finally(this.getTodayMember)
        .finally(this.getTodaySL)
        .finally(this.applyMonitorViewStyles);
    },

    applyMonitorViewStyles() {
      document.documentElement.classList.add("monitor-view");
      document.body.classList.add("monitor-view");
    },
    removeMonitorViewStyles() {
      document.documentElement.classList.remove("monitor-view");
      document.body.classList.remove("monitor-view");
    }
  }
};
</script>

<style>
@media (min-width: 1024px) {
  .monitor-view {
    font-size: 1.1rem;
  }

  .large-table .v-data-table-header th {
    font-size: 0.8rem;
    padding: 9px
  }

  .large-table .v-data-table__wrapper td {
    font-size: 1rem;
    padding: 8px;
    line-height: 1.5rem
  }
}

/* Stile für den Monitor-View */
html.monitor-view,
body.monitor-view {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

html.monitor-view .btn_logout {
  display: none !important;
}

/* Uhr in der App-Leiste (rechts) */
.appbar-clock {
  position: fixed;
  right: 14px;
  top: 6px; /* wird per JS feinjustiert */
  z-index: 1200; /* über App-Bar-Content */
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none; /* rein Anzeige, kein Klick */
  letter-spacing: 0.5px;
  font-variant-numeric: tabular-nums;
}

.scroll-sync {
  display: flex;
  overflow-x: auto;
}

.table-container {
  min-width: 33%;
  overflow: auto;
}
</style>